import { render } from "./App.vue?vue&type=template&id=6f2c8be7"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6f2c8be7&lang=css"

import exportComponent from "C:\\Users\\marka\\Desktop\\Projects\\numinix\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__